/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import CakeIcon from '@mui/icons-material/Cake'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt'
import HeightIcon from '@mui/icons-material/Height'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import FingerprintIcon from '@mui/icons-material/Fingerprint'
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly'
import WineBarIcon from '@mui/icons-material/WineBar'
import SmokingRoomsIcon from '@mui/icons-material/SmokingRooms'
import GrassIcon from '@mui/icons-material/Grass'
import ScienceIcon from '@mui/icons-material/Science'
import WorkIcon from '@mui/icons-material/Work'
import SchoolIcon from '@mui/icons-material/School'
import HomeIcon from '@mui/icons-material/Home'
import TempleBuddhistIcon from '@mui/icons-material/TempleBuddhist'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import TranslateIcon from '@mui/icons-material/Translate'
import Brightness3Icon from '@mui/icons-material/Brightness3'
import SearchIcon from '@mui/icons-material/Search'
import NotesIcon from '@mui/icons-material/Notes'

import { viewFeedbackAndVerdictForItemJSX } from '../../../analysisJSX/viewFeedbackAndVerdictForItemJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, hingeProfileBackgroundColor, hingeProfileImageDimension, hingeProfileItemBorderColor, hingeProfileItemDividerOpacity, hingeProfileItemBoxShadow, hingeProfileItemBorderWidth, hingeProfileItemBorderRadius, swipelyticsTurquoise, profPicDefaultURL } from '../../../../../helpers/variableDefaults'
import { inchesToFeetString } from '../../../../../helpers/globalHelpers'

export const viewHingeVitalInfoItem = (viewFeedbackTrue, giveFeedbackTrue, isFriendReview, user, datingProfile, width) => {

  return (
    <Box
      sx={{
        mt: 3,
        // py: 2, px: 2,
        width: hingeProfileImageDimension(width),
        borderRadius: hingeProfileItemBorderRadius, 
        // boxShadow: 3, 
        // border: 1,
        // borderColor: 'gainsboro',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      {/* Vital Info */}
      <Box
        sx={{
          // mt: 2,
          py: 2, px: 2,
          boxShadow: hingeProfileItemBoxShadow, 
          border: hingeProfileItemBorderWidth,
          borderColor: hingeProfileItemBorderColor,
          minWidth: hingeProfileImageDimension(width),
          width: hingeProfileImageDimension(width),
          backgroundColor: 'white',
          fontWeight: 'bold',
          borderRadius: viewFeedbackTrue || giveFeedbackTrue ? `${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius} 0px 0px` : `${hingeProfileItemBorderRadius}`, 
          whiteSpace: 'nowrap',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        {/* Top Row */}
        <Box
          sx={{
            pt: 1,
            pb: 1.5,
            // width: hingeProfileImageDimension(width),
            width: '100%',
            // maxWidth: hingeProfileImageDimension(width),
            // whiteSpace: 'nowrap',
            overflowX: 'scroll',
            '&::-webkit-scrollbar': {
              WebkitAppearance: 'none',
              width: '0px', height: '0px',
            },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: '4px',
              backgroundColor: 'rgba(0, 0, 0, .35)',
              webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
            },
            display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
            flexWrap: 'nowrap',
          }}
        >
          {/* Age */}
          {'age' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.age > 17 &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Icon */}
              <CakeIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Age */}
              <Typography
                sx={{

                }}
              >
                {datingProfile.bio.vitalInfo.age}
              </Typography>

              {/* Divider */}
              <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />
            </Box>
          }

          {/* Gender */}
          {'gender' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.gender.length > 0 &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Icon */}
              <PersonOutlineIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Gender */}
              <Typography
                sx={{

                }}
              >
                {datingProfile.bio.vitalInfo.gender}
              </Typography>

              {/* Divider */}
              <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />
            </Box>
          }

          {/* Sexuality */}
          {'sexuality' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.sexuality.length > 0 &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Icon */}
              <ElectricBoltIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Sexuality */}
              <Typography
                sx={{

                }}
              >
                {datingProfile.bio.vitalInfo.sexuality}
              </Typography>

              {/* Divider */}
              <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />
            </Box>
          }

          {/* Height */}
          {'heightInches' in datingProfile.bio.vitalInfo 
          && 'heightCM' in datingProfile.bio.vitalInfo 
          && (isFriendReview || 'inOrCmPreference' in user.bio.vitalInfo)
          && datingProfile.bio.vitalInfo.heightInches > 0 
          && datingProfile.bio.vitalInfo.heightCM > 0 
          && (isFriendReview || user.bio.vitalInfo.inOrCmPreference.length > 0) 
          &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >
              {/* Icon */}
              <HeightIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Height */}
              <Typography
                sx={{
                  // whiteSpace: 'nowrap',
                }}
              >
                {isFriendReview && datingProfile.bio.vitalInfo.inOrCmPreference === 'cm' 
                  ? 
                  `${datingProfile.bio.vitalInfo.heightCM} cm`
                  :
                  isFriendReview && datingProfile.bio.vitalInfo.inOrCmPreference !== 'cm'
                    ?
                    `${inchesToFeetString(datingProfile.bio.vitalInfo.heightInches)}`
                    :
                    user.bio.vitalInfo.inOrCmPreference === 'cm' 
                      ? 
                      `${datingProfile.bio.vitalInfo.heightCM} cm`
                      :
                      `${inchesToFeetString(datingProfile.bio.vitalInfo.heightInches)}`
                }
              </Typography>

              {/* Divider */}
              {('currentCity' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.currentCity.length > 0)
                &&
                <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />
              }
            </Box>
          }

          {/* Current City */}
          {'currentCity' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.currentCity.length > 0 &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Icon */}
              <LocationOnIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Current City */}
              <Typography
                sx={{
                  // whiteSpace: 'nowrap',
                }}
              >
                {datingProfile.bio.vitalInfo.currentCity}
              </Typography>

              {/* Divider */}
              {/* <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" /> */}
            </Box>
          }



          {/* Ethnicity */}
          {'ethnicity' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.ethnicity.length > 0 && datingProfile.bio.vitalInfo.ethnicity !== 'Prefer not to say' &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Divider */}
              <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />

              {/* Icon */}
              <FingerprintIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Family Plans */}
              <Typography
                sx={{
                  // whiteSpace: 'nowrap',
                }}
              >
                {datingProfile.bio.vitalInfo.ethnicity}
              </Typography>
            </Box>
          }

          {/* Children */}
          {'children' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.children.length > 0 
            && 
            datingProfile.bio.vitalInfo.children !== 'Prefer not to say' 
            &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Divider */}
              <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />

              {/* Icon */}
              <ChildFriendlyIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Children */}
              <Typography
                sx={{
                  // whiteSpace: 'nowrap',
                }}
              >
                {datingProfile.bio.vitalInfo.children}
              </Typography>
            </Box>
          }

          {/* Family Plans */}
          {'familyPlans' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.familyPlans.length > 0 && datingProfile.bio.vitalInfo.familyPlans !== 'Prefer not to say' &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Divider */}
              <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />

              {/* Icon */}
              <ChildFriendlyIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Family Plans */}
              <Typography
                sx={{
                  // whiteSpace: 'nowrap',
                }}
              >
                {datingProfile.bio.vitalInfo.familyPlans}
              </Typography>
            </Box>
          }

          {/* Alcohol */}
          {'alcohol' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.alcohol.length > 0 && datingProfile.bio.vitalInfo.alcohol !== 'Prefer not to say' &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Divider */}
              <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />

              {/* Icon */}
              <WineBarIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Alcohol */}
              <Typography
                sx={{
                  // whiteSpace: 'nowrap',
                }}
              >
                {datingProfile.bio.vitalInfo.alcohol}
              </Typography>
            </Box>
          }

          {/* Cigarettes */}
          {'cigarettes' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.cigarettes.length > 0 && datingProfile.bio.vitalInfo.cigarettes !== 'Prefer not to say' &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Divider */}
              <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />

              {/* Icon */}
              <SmokingRoomsIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Cigarettes */}
              <Typography
                sx={{
                  // whiteSpace: 'nowrap',
                }}
              >
                {datingProfile.bio.vitalInfo.cigarettes}
              </Typography>
            </Box>
          }

          {/* Weed */}
          {'weed' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.weed.length > 0 && datingProfile.bio.vitalInfo.weed !== 'Prefer not to say' &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Divider */}
              <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />

              {/* Icon */}
              <GrassIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Weed */}
              <Typography
                sx={{
                  // whiteSpace: 'nowrap',
                }}
              >
                {datingProfile.bio.vitalInfo.weed}
              </Typography>
            </Box>
          }

          {/* Drugs */}
          {'drugs' in datingProfile.bio.vitalInfo && datingProfile.bio.vitalInfo.drugs.length > 0 && datingProfile.bio.vitalInfo.drugs !== 'Prefer not to say' &&
            <Box
              sx={{
                // px: 1,
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Divider */}
              <Divider sx={{ height: '20px', mx: 1, opacity: hingeProfileItemDividerOpacity }} orientation="vertical" />

              {/* Icon */}
              <ScienceIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Drugs */}
              <Typography
                sx={{
                  // whiteSpace: 'nowrap',
                }}
              >
                {datingProfile.bio.vitalInfo.drugs}
              </Typography>
            </Box>
          }


        </Box>

        {/* Profession and Employer */}
        {
          (
            (
              'profession' in datingProfile.bio.vitalInfo 
              && datingProfile.bio.vitalInfo.profession.length > 0
            )
            ||
            (
              'employer' in datingProfile.bio.vitalInfo 
              && datingProfile.bio.vitalInfo.employer.length > 0
            ) 
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, opacity: hingeProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Profession and Employer */}
            <Box
              sx={{
                py: 1.5,
                // width: hingeProfileImageDimension(width),
                width: '100%',
                // maxWidth: hingeProfileImageDimension(width),
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <WorkIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Profession and Employer */}
              <Typography
                sx={{

                }}
              >
                {
                  'profession' in datingProfile.bio.vitalInfo 
                  && datingProfile.bio.vitalInfo.profession.length > 0
                  && 'employer' in datingProfile.bio.vitalInfo
                  && datingProfile.bio.vitalInfo.employer.length > 0
                    ?
                    `${datingProfile.bio.vitalInfo.profession} at ${datingProfile.bio.vitalInfo.employer}` 
                    :
                    'profession' in datingProfile.bio.vitalInfo 
                    && datingProfile.bio.vitalInfo.profession.length > 0
                      ?
                      `${datingProfile.bio.vitalInfo.profession}`
                      :
                      `${datingProfile.bio.vitalInfo.employer}`
                }
              </Typography>
              
            </Box>
          </>
        }
        

        {/* University */}
        {
          (
            'university' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.university.length > 0
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, opacity: hingeProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* University */}
            <Box
              sx={{
                py: 1.5,
                // width: hingeProfileImageDimension(width),
                width: '100%',
                // maxWidth: hingeProfileImageDimension(width),
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <SchoolIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* University */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.university}`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Religion (Array) */}
        {
          (
            'religion' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.religion.length > 0
            && !(datingProfile.bio.vitalInfo.religion.includes('Prefer not to say'))
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, opacity: hingeProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Religion */}
            <Box
              sx={{
                py: 1.5,
                // width: hingeProfileImageDimension(width),
                width: '100%',
                // maxWidth: hingeProfileImageDimension(width),
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <TempleBuddhistIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Religion */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.religion.join(', ')}`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Hometown */}
        {
          (
            'hometown' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.hometown.length > 0
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, opacity: hingeProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Hometown */}
            <Box
              sx={{
                py: 1.5,
                // width: hingeProfileImageDimension(width),
                width: '100%',
                // maxWidth: hingeProfileImageDimension(width),
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <HomeIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* University */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.hometown}`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Politics */}
        {
          (
            'politics' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.politics.length > 0
            && datingProfile.bio.vitalInfo.politics !== 'Prefer not to say' 
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, opacity: hingeProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Politics */}
            <Box
              sx={{
                py: 1.5,
                // width: hingeProfileImageDimension(width),
                width: '100%',
                // maxWidth: hingeProfileImageDimension(width),
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <AccountBalanceIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Politics */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.politics}`}
              </Typography>
              
            </Box>
          </>
        }

        {/* Languages (Array) */}
        {
          (
            'languages' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.languages.length > 0
            && !(datingProfile.bio.vitalInfo.languages.includes('Prefer not to say'))
          )
          &&
          <>
            {/* Divider */}
            <Divider sx={{ width: '100%', my: 0, opacity: hingeProfileItemDividerOpacity }} orientation="horizontal" />
            
            {/* Languages */}
            <Box
              sx={{
                py: 1.5,
                // width: hingeProfileImageDimension(width),
                width: '100%',
                // maxWidth: hingeProfileImageDimension(width),
                // whiteSpace: 'nowrap',
                overflowX: 'scroll',
                '&::-webkit-scrollbar': {
                  WebkitAppearance: 'none',
                  width: '0px', height: '0px',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .35)',
                  webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
                },
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <TranslateIcon sx={{ mr: 1, width: '15px', height: '15px' }} />

              {/* Languages */}
              <Typography
                sx={{

                }}
              >
                {`${datingProfile.bio.vitalInfo.languages.join(', ')}`}
              </Typography>
              
            </Box>
          </>
        }
      </Box>

      {/* Feedback */}
      {viewFeedbackTrue && datingProfile.bioFeedback.vitalInfoFeedback.feedback.length > 0 && datingProfile.bioFeedback.vitalInfoFeedback.verdict.length > 0 &&
        <Box
          sx={{
            width: hingeProfileImageDimension(width),
            borderRadius: `0px 0px ${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius}`,
            borderLeft: hingeProfileItemBorderWidth, borderRight: hingeProfileItemBorderWidth, borderBottom: hingeProfileItemBorderWidth,
            // boxShadow: hingeProfileItemBoxShadow,
            borderColor: hingeProfileBackgroundColor,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.bioFeedback.vitalInfoFeedback, 'vitalInfo', datingProfile.type)}

        </Box>
      }
    </Box>
  )
}